import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { exampleTableTechnicalData } from "../../../../components/comparison-table/comparison-table.templates";

export const TabTechnicaldata = () => html`
    <div id="tabTechnicaldata">
        <div class="ux-row ux-u-flex-jc-center ux-u-mx-zero">
            <div class="ux-col-12 ux-col-md-10 ux-u-mb-fluid-l">
                <ux-iws-comparison-table
                    variant="data"
                    full-width
                    sticky-header
                    sticky-row-header
                >
                    ${unsafeHTML(exampleTableTechnicalData)}
                </ux-iws-comparison-table>
            </div>
        </div>
    </div>
`;
